import fuse from '../../../_libs/redux-fusion';
import {isErrorViewMode, ViewMode} from '../../../_libs/redux-observable-list/src/enums';
import {getUserId} from '../../../auth/reducers';
import {supportsImportExport} from '../../../core-utilities-implementation/device-services/DeviceServicesCordova';
import {
  buildFilterData$,
  buildFilterModalOptions$,
  buildTotalProps$,
} from '../../../core-utilities/redux/ReduxListContainer';
import {priorityExportActions, sweepList} from '../../../priorities/actions';
import {getPinnedPrioritiesList} from '../../../priorities/reducers/state';
import {componentOptions as autoListComponentOptions, reduxList as autoList} from '../../../priorities/redux/autoList';
import {
  componentOptions as pinnedListComponentOptions,
  getPinnedFilterData,
  reduxList as pinnedList,
} from '../../../priorities/redux/pinnedList';
import {
  componentOptions as activeTimersComponentOptions,
  reduxList as activeTimers,
} from '../../../timers/redux/activeTimers';
import {
  componentOptions as userTodoListComponentOptions,
  userTodoListReduxList,
} from '../../../todo-messages/redux/userTodoList';
import {UserViewHomeView} from './UserViewHomeView';


const StreamedComponent = (state$, dispatch) => (props$) => {
  const onClickExport = () => {
    state$
      .take(1)
      .subscribe(rootState => {
        const listState = getPinnedPrioritiesList(rootState);
        const filterData = getPinnedFilterData(listState);
        dispatch(priorityExportActions.showModal(filterData));
      });
  };
  const onClickSweep = () => {
    dispatch(sweepList());
  };
  const onClickTodoMessageAction = (model, actionId) => {
    dispatch(userTodoListReduxList.actions.selectAction({
      id: model.id,
      actionId,
    }));
  };
  const onFilterChange = filterData => filter => {
    if (filterData.filter !== filter) {
      filterData.filter = filter;
      dispatch(userTodoListReduxList.actions.applyFilter({filter}));
      dispatch(autoList.actions.applyFilter(filterData));
      dispatch(pinnedList.actions.applyFilter(filterData));
    }
  };
  const onFilterOptionsUpdate = filterData => filterOptions => {
    if (filterData.filterOptions !== filterOptions) {
      filterData.filterOptions = filterOptions;
      dispatch(autoList.actions.applyFilter(filterData));
      dispatch(pinnedList.actions.applyFilter(filterData));
    }
  };
  const onSortOptionsUpdate = filterData => sortOptions => {
    if (filterData.sortOptions !== sortOptions) {
      filterData.sortOptions = sortOptions;
      dispatch(autoList.actions.applyFilter(filterData));
      dispatch(pinnedList.actions.applyFilter(filterData));
    }
  };

  const userId$ = state$
    .map(getUserId)
    .distinctUntilChanged()
    .takeUntil(props$.last());

  const filterData$ = buildFilterData$(state$, autoList.options);
  const autoListFilterOptions$ = buildFilterModalOptions$(state$, {
    ...autoListComponentOptions,
    searchOnly: false,
  }, autoList.options);
  const todoMessagesState$ = buildTotalProps$(state$, userTodoListComponentOptions, userTodoListReduxList.options);
  const activeTimersState$ = buildTotalProps$(state$, activeTimersComponentOptions, activeTimers.options);
  const pinnedListState$ = buildTotalProps$(state$, pinnedListComponentOptions, pinnedList.options);
  const autoListState$ = buildTotalProps$(state$, autoListComponentOptions, autoList.options);
  const eventHandlers$ = filterData$
    .map(
      filterData => ({
        onFilterChange: onFilterChange(filterData),
        onFilterOptionsUpdate: onFilterOptionsUpdate(filterData),
        onSortOptionsUpdate: onSortOptionsUpdate(filterData),
      })
    );

  return props$
    .combineLatest(
      userId$,
      eventHandlers$,
      autoListFilterOptions$,
      todoMessagesState$,
      activeTimersState$,
      pinnedListState$,
      autoListState$,
      (
        props,
        userId,
        eventHandlers,
        autoListFilterOptions,
        todoMessagesState,
        activeTimersState,
        pinnedListState,
        autoListState,
      ) => ({
        ...props,
        ...eventHandlers,
        userId,
        overallMode: getMode(pinnedListState, autoListState),
        showTodoMessages: showList(todoMessagesState),
        showActiveTimers: showList(activeTimersState),
        filterModalOptions: autoListFilterOptions,
        canExport: supportsImportExport(),
        todoMessagesState,
        activeTimersState,
        pinnedListState,
        autoListState,
        onClickExport,
        onClickSweep,
        onClickTodoMessageAction,
      })
    );
};

export const UserViewHomeContainer = fuse(StreamedComponent)(UserViewHomeView);

function getMode(pinnedListState, autoListState) {
  if (pinnedListState.mode === ViewMode.LOADING || autoListState.mode === ViewMode.LOADING) {
    return ViewMode.LOADING;
  } else if (isErrorViewMode(pinnedListState.mode)) {
    return pinnedListState.mode;
  } else if (isErrorViewMode(autoListState.mode)) {
    return autoListState.mode;
  } else {
    return null;
  }
}

function showList(listData) {
  return listData.mode === ViewMode.ENONET || listData.mode === ViewMode.EOTHER || listData.total > 0;
}



// WEBPACK FOOTER //
// ./src/js/user/components/UserViewHome/UserViewHomeContainer.js